// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3qPZB","title":"FrontImage_title__24Oj2"};